/**
 * W tym pliku zamieszczać funkcje wspólne nieużywające htmlu
 * Te funkcje MUSZĄ być oddzielnie od wspólnych funkcji używających htmlu,
 * gdyż biblioteki typescript w trybie html i serviceworker konfliktują ze sobą
 */



export function showPromiseError(message: string, ...optionalObjects: any[]) {
    return (error: any) => {console.error(message,error, ...optionalObjects); return error};
}

export function asyncDelay(timeMillis: number) {
    return new Promise((resolve) => {
        self.setTimeout(resolve,timeMillis);
    })
}

/**
 * Zwraca listę metod w podanym obiekcie
 * @param object
 */
export function getAllFunctionsFromObject(object: object):string[] {
    const prototype = Object.getPrototypeOf(object);
    const result:any = {};
    if(!prototype) {
        return [];
    }
    for(let m of Object.getOwnPropertyNames(object)) {
        //@ts-ignore
        if(typeof(object[m]) === 'function' && m!== 'constructor') {
            result[m] = true;
        }
    }
    for(let m of getAllFunctionsFromObject(prototype)) {
        result[m] = true;
    }
    return Object.keys(result);
}
/**
 * Zwraca listę properek które nie są metodami w podanym obiekcie
 * @param object
 */
export function getAllNonFunctionsFromObject(object: object):string[] {
    const prototype = Object.getPrototypeOf(object);
    const result:any = {};
    if(!prototype) {
        return [];
    }
    for(let m of Object.getOwnPropertyNames(object)) {
        //@ts-ignore
        if(!(typeof(object[m]) === 'function' && m!== 'constructor')) {
            result[m] = true;
        }
    }
    for(let m of getAllNonFunctionsFromObject(prototype)) {
        result[m] = true;
    }
    return Object.keys(result);
}
export function generateRandomString(length = 10) {
    const letters = 'abcdefghjkmnpqrstuvw23456789';
    let result = [];
    for(let i = 0 ; i < length ; i++) {
        result.push(letters[Math.random() * letters.length])
    }
    return result.join('');
}
/**
 * Wysyłka wiadomości niezależnie czy celem jest inny window, serviceworker, messageport
 * @param destination
 * @param message
 */
export function postNfMessage(destination:any | null, message: any) {
    if (!destination)
        return;
    if(destination.location) {
        destination.postMessage(message,'*');
    } else {
        destination.postMessage(message);
    }
}

/**
 * Zwraca obiekt nie opakowany w proxy
 * Używać przy wysyłaniu przez postMessage obiektów które wcześniej były np. w $data,
 * gdyż te wszystkie obiekty są automatycznie konwertowane na proxy, których postMessage nie wyśle
 * @param proxyObject
 */
export function unPackProxyObject<T extends unknown>(proxyObject: T): T {
    if (proxyObject === undefined)
        return undefined as T;
    return JSON.parse(JSON.stringify(proxyObject));
}

export function camelCaseToKebabCase(str: string) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}

/**
 * Zwraca wynik ze scryptu javascript, który zostanie uruchomiony w podanym kontekście (properki obiektu context będą widoczne jakby były normalnymi zmiennymi)
 * @param scriptEval
 * @param context
 */
export function evaluateResultWithContext(scriptEval: string|null, context: any) {
    if (null === scriptEval) {
        return null;
    }
    try {
        const f = new Function('context', "with(context) { return " + scriptEval + '}');
        return f(context);
    } catch (e) {
        console.error('Error while evaluating script', scriptEval, context, e);
        return null;
    }
}